if (!customElements.get("variant-select-picker")) {
  customElements.define(
    "variant-select-picker",
    class VariantSelects extends HTMLElement {
      pickerDom = null;
      dropdownDom = null;
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            "variant-selects select option[selected], variant-selects fieldset input:checked"
          )
        ).map(({ dataset }) => dataset.optionValueId);
      }

      connectedCallback() {
        this.pickerDom = this.querySelector(".variant-select-picker");
        this.dropdownDom = this.querySelector(".picker-options-dropdown");
        this.pickerDom.addEventListener("click", this.toggleDropdown);
        window.addEventListener("click", this.clickOtherToClose);
        this.dropdownDom.addEventListener("click", this.dropdownSelect);
      }

      findOptionDom = (dom, endDom) => {
        if (!dom || dom === endDom) return null;
        if (dom.classList.contains("option")) return dom;
        if (dom.parentElement) {
          return this.findOptionDom(dom.parentElement, endDom);
        }
        return null;
      };

      dropdownSelect = (event) => {
        const target = event.target;
        const optionDom = this.findOptionDom(target, this.dropdownDom);
        const optionValueId = optionDom?.dataset["optionValueId"],
          targetId = optionDom.dataset["id"];
        if (optionValueId) {
          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
            {
              data: {
                event,
                target,
                selectedOptionValues: [optionValueId],
                from: "variantSelectPicker",
              },
            }
          );
        }
      };

      clickOtherToClose = (e) => {
        const target = e.target;
        if (!this.contains(target)) {
          const isExpend = this.pickerDom.classList.contains("expended");
          if (isExpend) {
            this.pickerDom.classList.remove("expended");
          }
        }
      };

      scrollToSelectedOption = () => {
        const optionDom = this.dropdownDom.querySelector(".option.selected");
        if (!optionDom) return;
        const dropdownDomRect = this.dropdownDom.getBoundingClientRect(),
          optionRect = optionDom.getBoundingClientRect();
        if (dropdownDomRect.bottom < optionRect.bottom) {
          this.dropdownDom.scrollTop +=
            optionRect.bottom - dropdownDomRect.bottom + optionRect.height;
        } else if (dropdownDomRect.top > optionRect.top) {
          this.dropdownDom.scrollTop +=
            dropdownDomRect.top - dropdownDomRect.top + optionRect.height;
        }
      };

      toggleDropdown = (e) => {
        const isExpend = this.pickerDom.classList.contains("expended");
        if (isExpend) {
          this.pickerDom.classList.remove("expended");
        } else {
          // const target = e.target
          // if (this.dropdownDom.contains(target)) return
          this.pickerDom.classList.add("expended");
          setTimeout(() => {
            this.scrollToSelectedOption();
          });
        }
      };
    }
  );
}
